import { useEffect, useState } from "react";
import "../styles/Flagged.css";
import axiosClient from "../api/axiosClient";
import FlaggedTable from "../Components/FlaggedTable";

function ScardIconBox({ icon, bg, color }) {
  return (
    <div className="scard-icon-box" style={{ background: bg, color }}>
      {icon}
    </div>
  );
}

function ScardTrend({ trend, pct, label }) {
  const scardArrow = trend === "up" ? "↗" : "↘";

  return (
    <div className={`scard-trend scard-trend--${trend}`}>
      {/* <span className="scard-trend-arrow">{scardArrow}</span> */}
      <span className="scard-trend-pct">{pct}</span>
      <span className="scard-trend-label">{label}</span>
    </div>
  );
}

function ScardCard({ card }) {
  return (
    <div className="scard-card">
      <div className="scard-top">
        <span className="scard-label">{card.scardLabel}</span>

        <ScardIconBox
          icon={card.scardIcon}
          bg={card.scardIconBg}
          color={card.scardIconColor}
        />
      </div>

      <div className="scard-value">{card.scardValue}</div>

      <ScardTrend
        trend={card.scardTrend}
        pct={card.scardTrendPct}
        label={card.scardTrendLabel}
      />
    </div>
  );
}

export default function FlaggedPage({
  pageSize,
  onUserClick,
  setSearch,
  setPageIndex,
  fetchStats,
  search,
  data,
  totalPages,
  pageIndex,
}) {
  const [statsData, setstatsdata] = useState();

  const handleblocklist = async () => {
    try {
      const token = localStorage.getItem("admintoken");

      const res = await axiosClient.get(
        "/auth/admin/blockedUserList",
        {
          params: {
            page: 0,
            size: 10,
          },
          headers: {
            Authorization: `${token}`,
          },
        }
      );

      console.log(res);

      setstatsdata(res);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleblocklist();
  }, []);

  // only blocked card
  const scardData = [
    {
      scardId: "scard-blocked",
      scardLabel: "Blocked Users",
      scardValue: statsData?.data.totalItems || 0,
      scardIcon: "📉",
      scardIconBg: "#FFE8E8",
      scardIconColor: "#e5484d",
      // scardTrend: "down",
      // scardTrendPct: "4.3%",
      // scardTrendLabel: "Down from yesterday",
    },
  ];

  return (
    <div className="scard-page">
      <div className="scard-grid">
        {scardData.map((card) => (
          <ScardCard key={card.scardId} card={card} />
        ))}
      </div>

      {/* flaggedtable */}

      
      <FlaggedTable
        // pageSize={pageSize}
        // onUserClick={onUserClick}
        // setSearch={setSearch}
        // setPageIndex={setPageIndex}
        // fetchStats={fetchStats}
        // search={search}
        // data={data}
        // totalPages={totalPages}
        // pageIndex={pageIndex}
      />
     
    </div>
  );
}